module.exports = __webpack_public_path__ + "static/media/unknown.0fe2836e.svg";